
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/datenschutz",
      function () {
        return require("private-next-pages/datenschutz.tsx");
      }
    ]);
  